// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23949ba4%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27m6 9 6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ban-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 16px;
}

.ban-modal-card {
  width: 100%;
  max-width: 480px;
  background: #1e1f22;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(237, 66, 69, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.ban-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.ban-modal-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.ban-icon-wrap {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(237, 66, 69, 0.15);
  color: #ed4245;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.ban-modal-title h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #f2f3f5;
  letter-spacing: -0.2px;
}

.ban-modal-close-btn {
  background: transparent;
  border: none;
  color: #949ba4;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.ban-modal-close-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #dbdee1;
}

.ban-modal-body {
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.ban-target-preview {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  background: #111214;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
}

.ban-avatar-wrap {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  background: #5865f2;
}

.ban-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ban-avatar-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 18px;
}

.ban-target-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.ban-target-name {
  display: flex;
  align-items: baseline;
  gap: 6px;
  flex-wrap: wrap;
}

.ban-target-name .display-name {
  font-size: 15px;
  font-weight: 700;
  color: #f2f3f5;
}

.ban-target-name .user-tag {
  font-size: 12px;
  color: #949ba4;
}

.ban-target-id {
  font-size: 11px;
  color: #80848e;
  font-family: monospace;
}

.ban-warning-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  background: rgba(237, 66, 69, 0.08);
  border: 1px solid rgba(237, 66, 69, 0.25);
  border-radius: 10px;
  font-size: 13px;
  color: #f29b9d;
  line-height: 1.45;
}

.warning-icon {
  color: #ed4245;
  flex-shrink: 0;
  margin-top: 1px;
}

.ban-form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ban-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #b5bac1;
  text-transform: uppercase;
}

.ban-label .optional-tag {
  font-size: 11px;
  font-weight: 400;
  color: #80848e;
  text-transform: none;
}

.ban-select-wrapper {
  position: relative;
}

.ban-select {
  width: 100%;
  padding: 12px 14px;
  background: #111214;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  color: #dbdee1;
  font-size: 14px;
  font-weight: 500;
  outline: none;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 14px center;
}

.ban-select:focus {
  border-color: #5865f2;
  box-shadow: 0 0 0 2px rgba(88, 101, 242, 0.25);
}

.ban-helper-text {
  font-size: 12px;
  color: #949ba4;
  margin-top: -2px;
}

.ban-textarea {
  width: 100%;
  padding: 12px 14px;
  background: #111214;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  color: #dbdee1;
  font-size: 14px;
  outline: none;
  resize: vertical;
  min-height: 70px;
  box-sizing: border-box;
  font-family: inherit;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.ban-textarea:focus {
  border-color: #ed4245;
  box-shadow: 0 0 0 2px rgba(237, 66, 69, 0.2);
}

.ban-modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.ban-btn-cancel {
  padding: 10px 18px;
  background: transparent;
  border: none;
  color: #f2f3f5;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
}

.ban-btn-cancel:hover {
  background: rgba(255, 255, 255, 0.07);
}

.ban-btn-confirm {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 22px;
  background: #ed4245;
  border: none;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(237, 66, 69, 0.35);
  transition: all 0.15s ease;
}

.ban-btn-confirm:hover:not(:disabled) {
  background: #da373a;
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(237, 66, 69, 0.45);
}

.ban-btn-confirm:active:not(:disabled) {
  transform: translateY(0);
}

.ban-btn-confirm:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ban-spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/components/BanModal/BanModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,6EAA6E;EAC7E,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,8CAA8C;EAC9C,gBAAgB;EAChB,yDAAwQ;EACxQ,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".ban-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 16px;\n}\n\n.ban-modal-card {\n  width: 100%;\n  max-width: 480px;\n  background: #1e1f22;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(237, 66, 69, 0.15);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.ban-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px 16px 24px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.ban-modal-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.ban-icon-wrap {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: rgba(237, 66, 69, 0.15);\n  color: #ed4245;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.ban-modal-title h3 {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 700;\n  color: #f2f3f5;\n  letter-spacing: -0.2px;\n}\n\n.ban-modal-close-btn {\n  background: transparent;\n  border: none;\n  color: #949ba4;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.ban-modal-close-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #dbdee1;\n}\n\n.ban-modal-body {\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.ban-target-preview {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 16px;\n  background: #111214;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n}\n\n.ban-avatar-wrap {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n  background: #5865f2;\n}\n\n.ban-avatar-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.ban-avatar-fallback {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 700;\n  font-size: 18px;\n}\n\n.ban-target-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.ban-target-name {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.ban-target-name .display-name {\n  font-size: 15px;\n  font-weight: 700;\n  color: #f2f3f5;\n}\n\n.ban-target-name .user-tag {\n  font-size: 12px;\n  color: #949ba4;\n}\n\n.ban-target-id {\n  font-size: 11px;\n  color: #80848e;\n  font-family: monospace;\n}\n\n.ban-warning-box {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px 14px;\n  background: rgba(237, 66, 69, 0.08);\n  border: 1px solid rgba(237, 66, 69, 0.25);\n  border-radius: 10px;\n  font-size: 13px;\n  color: #f29b9d;\n  line-height: 1.45;\n}\n\n.warning-icon {\n  color: #ed4245;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.ban-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ban-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  color: #b5bac1;\n  text-transform: uppercase;\n}\n\n.ban-label .optional-tag {\n  font-size: 11px;\n  font-weight: 400;\n  color: #80848e;\n  text-transform: none;\n}\n\n.ban-select-wrapper {\n  position: relative;\n}\n\n.ban-select {\n  width: 100%;\n  padding: 12px 14px;\n  background: #111214;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  color: #dbdee1;\n  font-size: 14px;\n  font-weight: 500;\n  outline: none;\n  cursor: pointer;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23949ba4' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 14px center;\n}\n\n.ban-select:focus {\n  border-color: #5865f2;\n  box-shadow: 0 0 0 2px rgba(88, 101, 242, 0.25);\n}\n\n.ban-helper-text {\n  font-size: 12px;\n  color: #949ba4;\n  margin-top: -2px;\n}\n\n.ban-textarea {\n  width: 100%;\n  padding: 12px 14px;\n  background: #111214;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  color: #dbdee1;\n  font-size: 14px;\n  outline: none;\n  resize: vertical;\n  min-height: 70px;\n  box-sizing: border-box;\n  font-family: inherit;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.ban-textarea:focus {\n  border-color: #ed4245;\n  box-shadow: 0 0 0 2px rgba(237, 66, 69, 0.2);\n}\n\n.ban-modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 8px;\n  padding-top: 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.ban-btn-cancel {\n  padding: 10px 18px;\n  background: transparent;\n  border: none;\n  color: #f2f3f5;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.ban-btn-cancel:hover {\n  background: rgba(255, 255, 255, 0.07);\n}\n\n.ban-btn-confirm {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 22px;\n  background: #ed4245;\n  border: none;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  box-shadow: 0 4px 14px rgba(237, 66, 69, 0.35);\n  transition: all 0.15s ease;\n}\n\n.ban-btn-confirm:hover:not(:disabled) {\n  background: #da373a;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(237, 66, 69, 0.45);\n}\n\n.ban-btn-confirm:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.ban-btn-confirm:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.ban-spinner {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
